import { render, staticRenderFns } from "./LocationMappingRow.vue?vue&type=template&id=484b2b8c"
import script from "./LocationMappingRow.vue?vue&type=script&lang=js"
export * from "./LocationMappingRow.vue?vue&type=script&lang=js"
import style0 from "./LocationMappingRow.vue?vue&type=style&index=0&id=484b2b8c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports